export const constant = {
  ASSISTANT: 'assistant',
};
